import type {
  TCreateMinorAction,
  TSubmitMinorActionResponse,
} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TFormError, TGameId} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import {transformGameData} from '~/api/endpoints/game/GetGameData'
import gameDataMock from '~/api/endpoints/game/GetGameData/mock'

const endpoint = endpoints.gameplay.submitMinorAction

/**
 * Respond to an attack, like a rent / sly deal / etc.
 */
export default class SubmitMinorAction extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: TCreateMinorAction,
    pathPieces: {gameId: TGameId}
  ): TFormError | null {
    if (pathPieces.gameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TSubmitMinorActionResponse {
    return {
      gameData: gameDataMock,
    }
  }

  protected transformResponse(r: TSubmitMinorActionResponse) {
    return {
      ...r,
      gameData: transformGameData(r.gameData),
    }
  }
}
